var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerifiedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 41,
    viewBox: "0 0 26 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 40,
    rx: 4.5,
    fill: "white",
    stroke: "#FA9418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 3.79086 3.79086 2 6 2H20C22.2091 2 24 3.79086 24 6V35C24 37.2091 22.2091 39 20 39H6C3.79086 39 2 37.2091 2 35V6Z",
    fill: "#FA9418"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 35,
    width: 8,
    height: 2,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5001 14.5L10.9477 25.6628C10.6199 25.9299 10.1947 26.0462 9.77668 25.9833C9.35864 25.9203 8.98659 25.6838 8.75208 25.332L5.75208 20.832C5.29256 20.1428 5.47882 19.2114 6.16811 18.7519C6.8574 18.2924 7.78871 18.4787 8.24823 19.1679L10.3325 22.2943L24.5001 10.5V14.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.84ee1b687aa88cbb5ac1f88f3b1d6baf.svg";
export { ForwardRef as ReactComponent };